// The person card overlay root: reads the selected person from the store (24.14 overlay root).
import { closeOverlay, draft, game, openPersonCard, renamePerson, runConfig, status, ui } from '../../store';
import { personCardVM } from '../../viewModels';
import { PersonCard } from './person-card';
import './people.css';

export function PersonCardRoot() {
  const g = game.value;
  const id = ui.value.selectedPersonId;
  if (g === null || id === null) return null;
  const vm = personCardVM(g, draft.value, id, runConfig());
  if (vm === null) return null;
  return (
    <PersonCard
      key={id}
      vm={vm}
      canEdit={status.value === 'deciding'}
      onRename={(name) => renamePerson(id, name)}
      onOpenPerson={openPersonCard}
      onClose={() => closeOverlay()}
    />
  );
}
